/**
 * <SelectStudent
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import SelectStudentModal from 'template/Modals/SelectStudent';
import './SelectItems.scss';

import { ITEM_NAME_LIST_LENGTH } from '../constants';

export function selectStudent (props) {
  let value = parseJsonStrValue(props.value);
  return <SelectStudent {...props} value={value} onChange={(data)=>{ props.onChange(JSON.stringify(data)); }} />
}

class SelectStudent extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);

    this.state = {
      studentNames: [],
      studentIds: [],
      students: [],
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({
        students: nextProps.value,
      });
    }
  }

  onChange() {
    let {
      options = {},
      onChange,
      selectFilter,
    } = this.props;

    let {
      selectMultiple,
    } = options;

    let {
      students,
    } = this.state;

    let schoolId = localStorage.getItem('schoolId');

    SelectStudentModal({
      schoolId,
      selectMultiple,
      selected: students,
    })
      .then((studentsOut)=>{
        let studentIds = [];
        let students = [];

        if (!Array.isArray(studentsOut)) {
          students = [studentsOut];
        } else {
          students = studentsOut;
        }

        students.map((student)=>{
          studentIds.push(student.schoolStudentId);
        });

        this.setState({
          studentIds,
          students,
        });

        onChange(students);
      })
      .catch((err)=>{
        console.error(err);
      });
  }

  render() {
    let {
      students,
    } = this.state;

    let { disabled } = this.props

    let studentNamesText;

    if (students && students.length > 0) {
      let comma = '';
      let trailing = '';
      let studentsInRange = students.slice(0, ITEM_NAME_LIST_LENGTH);

      let totalText = __('Total {number}: ', 'SelectStudentField', { number: students.length });

      studentNamesText = studentsInRange.map((student, idx)=>{
        if (idx === ITEM_NAME_LIST_LENGTH - 1 && students.length > ITEM_NAME_LIST_LENGTH) {
          trailing = __('...', 'SelectStudentField');
        }

        let StudentLink = <span key={idx}>{totalText}{comma}{student.name}{trailing}</span>;

        totalText = ''; // We only need it once.

        comma = ', ';

        return StudentLink;
      });

    } else {
      studentNamesText = <span className='no-items'>{__('Not Assigned', 'others')}</span>;
    }

    return (
      <div className='select-items-button'>
        <div className='item-names col-sm-10'>
          {studentNamesText}
        </div>
        <div className={`select-toolbar col-sm-2 ${disabled ? 'disabled' : ''}`}>
          <button className='btn-link pull-right' onClick={this.onChange} disabled={disabled} >{__('Select', 'class')}</button>
        </div>
      </div>
    )
  }
}

export default SelectStudent;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SelectStudent.js